module.exports = __webpack_public_path__ + "static/media/synergix.8fc54720.png";